import React, { useEffect, useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import PayUForm from './Utils/PayUForm';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
//import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
//import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import UtilityBillsDthPay from './Recharge/UtilityBillsDthPay';
import WifiInternet from './Recharge/WifiInternet';
import { useSelector } from "react-redux";
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function IndianRecharge() {
  const currentUser = useSelector((state) => state.data);
  const [errors, setErrors] = useState(false);
  const [formData, setFormData] = useState(false);
  const [operatorList, setOperatorList] = useState(false);
  const [stateList, setStateList] = useState(false);
  const [planList, setPlanList] = useState(false);
  const [payuData, setPayuData] = useState(false);
  const [operatorId, setOperatorId] = useState(false);
  const getPlan = async (e) => {
    try {
      if (e.target.name == "operatorId") {
        setStateList(false);
        setPlanList(false);
        setOperatorId(e.target.value);
        getData2();
      } else {
        const response = await axios.post('/indian/getPrepaidPlanList', { operatorId, stateId: e.target.value });
        const { status, data } = response.data;
        if (status) {
          setPlanList(data);
        }
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { MobileNumber, operatorId, Amount, wallet_type } = e.target;
    try {
      // const isValid = /^\d{10}$/.test(MobileNumber.value);
      // if (!isValid) {
      //   setErrors({ MobileNumber: "Mobile should be 10 number" });
      // }
      // else {
        setErrors(false);
        let sendData = {
          service: "indianRecharge",
          service_provider: operatorId.value,
          mobile: MobileNumber.value,
          amount: Amount.value * 1.6,
          wallet_type: wallet_type.value,
        };
        //const response = await axios.post("/indian/indianRecharge", sendData);
        const response = await axios.post("/recharge/services/pay", sendData);
        const { status, message, hashData, rechage_response: rd } = response.data;
        if (status) {
          if (hashData) {
            const payuData = {
              hash: hashData.hash,
              txnid: hashData.txId,
              amount: hashData.amount,
              firstname: currentUser.name,
              email: currentUser.email,
            };
            setPayuData(payuData);
          }
          else {
            let rechrgeMessage = "<table align='center'><tr><td>Mobile</td><td>" + rd.mobile + "</td></tr><tr><td>Amount</td><td>" + rd.amount + "</td></tr><tr><td>Receipt</td><td>" + rd.reciept + "</td></tr><tr><td>Transaction ID</td><td>" + rd.transaction_id + "</td></tr><tr><td colspan='100%'>" + rd.message + "</td></tr></table>"
            Swal.fire({
              title: 'Recharge Successful!',
              html: rechrgeMessage,
              icon: 'success',
              //confirmButtonText: 'OK'
            });
            setFormData({ MobileNumber: "" });
          }
        }
        else {
          toast(message);
        }
      //}
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getData1 = async () => {
    try {
      const response = await axios.post('/indian/getOperatorList');
      const { status, data } = response.data;
      if (status) {
        setOperatorList(data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  const getData2 = async () => {
    try {
      const response = await axios.post('/indian/getStateList');
      const { status, data } = response.data;
      if (status) {
        setStateList(data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData1();
  }, []);
  return (
    <>
      {
        payuData && (
          <PayUForm formData={payuData} autoSubmit={true} />
        )
      }
      <div class="content-wrapper">
        <div class="row">
          <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Recharge</h4>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                  <Row>
                    <Col sm={3}>
                      <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                          <Nav.Link eventKey="first">Mobile Topup</Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={9}>
                      <Tab.Content>
                        <Tab.Pane eventKey="first">
                          <Form onSubmit={handleSubmit}>
                            <div className="row">
                              <div class="col-lg-12 col-md-12">
                                <label>Mobile Number</label>
                                <input class="form-control" type="text" name="MobileNumber" value={formData?.MobileNumber} required />
                                <span className="error">{errors && errors?.MobileNumber}</span>
                              </div>
                              <div class="col-lg-12 col-md-12">
                                <label>Operator</label>
                                <select class="form-control" name="operatorId" onChange={(e) => getPlan(e)} required>
                                  <option value="">--Select--</option>
                                  {
                                    operatorList && operatorList.map(prov => (
                                      <option value={prov._id}>{prov.provider_name}</option>
                                    ))
                                  }
                                </select>
                              </div>
                              <div class="col-lg-12 col-md-12">
                                <label>State</label>
                                <select class="form-control" name="stateId" onChange={(e) => getPlan(e)} required>
                                  <option value="">--Select--</option>
                                  {
                                    stateList && stateList.map(prov => (
                                      <option value={prov.stateId}>{prov.name}</option>
                                    ))
                                  }
                                </select>
                              </div>
                              <div class="col-lg-12 col-md-12">
                                <label>Amount</label>
                                {planList && planList.length > 0 ? (
                                  <select class="form-control" name="Amount" required>
                                    <option value="">--Select--</option>
                                    {planList && planList.map((plan, index) => (
                                      <option value={plan.amount}>
                                        Rs. {plan.amount} | {plan.detail}
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  <>
                                    <input class="form-control" type="number" name="Amount" required />
                                  </>
                                )}
                              </div>
                              <div class="col-lg-12 col-md-12">
                                <label>Wallet Type</label>
                                <select class="form-control" name="wallet_type" required>
                                  <option value="">--Select--</option>
                                  <option value="wallet">Wallet</option>
                                  <option value="remitance">Remitance</option>
                                  <option value="payu">Online payment(Payu)</option>
                                </select>
                              </div>
                              <div class="col-lg-12 col-md-12">
                                <input type="submit" className="search-btn btn btn-primary" value="Recharge" />
                              </div>
                            </div>
                          </Form>
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IndianRecharge;
